
@if (dailyPoints() && dailyPoints().length > 0) {
  <!--<app-start-point />-->
  
  <section class="route-timeline__points">
    @for (point of dailyPoints(); track point.id; let i = $index) {
      @if (pointStatuses()[i]) {
        <app-card 
          [indexCard]="i"
          [point]="point"
          [previousPointTitle]="previousTitles[i]"
          [transportList]="point.transportList"
          [status]="pointStatuses()[i]"
          [attr.data-status]="pointStatuses()[i]"
          [attr.data-scroll-index]="i"
        />
      }
    } 
  </section>
}